import Link from 'next/link';

interface ToolHeroProps {
  title: string;
  description: string;
  category?: string;
}

export default function ToolHero({ title, description, category }: ToolHeroProps) {
  return (
    <section className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Breadcrumbs */}
        <nav className="flex items-center gap-2 text-sm text-blue-200 mb-6">
          <Link href="/" className="hover:text-white transition-colors">Home</Link>
          <span>/</span>
          <Link href="/tools" className="hover:text-white transition-colors">Tools</Link>
          <span>/</span>
          <span className="text-white">{title}</span>
        </nav>

        {category && (
          <span className="inline-block bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full mb-4">
            {category}
          </span>
        )}

        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4 animate-in fade-in slide-in-from-bottom-4 duration-500">
          {title}
        </h1>
        <p className="text-lg text-blue-100 max-w-2xl animate-in fade-in slide-in-from-bottom-4 duration-700" style={{ animationDelay: '100ms' }}>
          {description}
        </p>
      </div>
    </section>
  );
}
